import { textStyleCss } from 'src/theme/atlas';
import styled from 'styled-components';

export const Label = styled.label`
  margin-bottom: 12px;
  display: block;
  color: ${(props) => props.theme.atlas.semantic.color.type.default};
  ${({ theme }) => textStyleCss(theme.atlas.typography.semantic.bodySmall)};
  font-weight: ${(props) => (props.theme.isVaultVariant ? 500 : 600)};
`;
